import { data } from "../constants/Constants";
import localStorageCustom from "../utilitarios/localStorage";
const axios = require('axios')
const qs = require('qs')

const SERVICE_ENVIROMENT = {

    DEV: "https://b2bv2.asiri.pe/api/",
    PROD: "https://b2bv2.asiri.pe/api/",


    // DEV: "https://apib2bdev.crosland.com.pe:4436/api/",
    // PROD: "https://apib2bdev.crosland.com.pe:4436/api/",

} 

const baseURL = SERVICE_ENVIROMENT[data.enviroment];

// export 
const baseInstanceAxios = axios.create({
    baseURL,
    timeout: 1000000,
});

const getToken = () => {
    try {
        let token = localStorageCustom.prototype.getToken();
        // console.log("token", token)
        return token;
    } catch (error) {
        // console.log("getToken ERROR:", error.message);
        return;
    }
};

const isAxiosHandlerEnabled = (config = {}) => {
    // return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ? false : true;
    return Object.prototype.hasOwnProperty.call(config, "handlerEnabled") &&
        !config.handlerEnabled ?
        false :
        true;
};

const requestAxiosHandler = request => {
    if (isAxiosHandlerEnabled(request)) {
        const token = getToken();
        request.headers["Content-Type"] = "application/x-www-form-urlencoded";
        if (token)
            request.headers["Authorization"] = "Bearer " + token;

    }
    return request;
};

const successAxiosHandler = response => {
    if (isAxiosHandlerEnabled(response.config)) {
        if (response.status == 200) {
            // Handle responses
            // if (response.data.mo.type = "success") {
            return response.data;
            // }
            // throw new Error(response.statusText);

        }
    }
    throw new Error(response.statusText);
};

const errorAxiosHandler = error => {
    if (isAxiosHandlerEnabled(error.config)) {
        console.log("errorAxiosHandler >", error);
    }
    if (error.message == "Network request failed" || error.message == "Network Error") {
        error.message = "Por favor, asegúrate de estar conectado a internet y vuelve a intentarlo";
        error.description = "Por favor, asegúrate de estar conectado a internet y vuelve a intentarlo";
    }

    return Promise.reject({ ...error });
};

// Add interceptors
baseInstanceAxios.interceptors.request.use(request =>
    requestAxiosHandler(request)
);

baseInstanceAxios.interceptors.response.use(
    response => successAxiosHandler(response),
    error => errorAxiosHandler(error)
);

class ServiceManager {
    Get(params, test = false) {
        let { url = null, urlIsRelative = true } = params;
        return baseInstanceAxios
            .get(url)
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    }

    Post(params, test = false) {
        let { url = null, data = null, urlIsRelative = true } = params;
        data = qs.stringify(data);
        // console.log("data", data)
        return baseInstanceAxios
            .post(url, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                throw error;
            });
    }
}

export default ServiceManager;